import { useState } from 'react'
import {
    EstablishmentPicturesResponse,
    UpdateEstablishmentPicturesRequest,
} from '../../resources/establishment/types'
import { mutations } from '../../resources'
import actions from '../../store/actions'
import { generateError } from '../../helpers/errors'
import { useDispatch } from '../redux'

export const useEstablishmentPicturesUpdate = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const updateEstablishmentPictures = (
        payload: UpdateEstablishmentPicturesRequest,
    ): Promise<EstablishmentPicturesResponse> => {
        setInProgress(true)
        return mutations
            .updateEstablishmentPictures(payload)
            .then((response) => {
                dispatch(actions.setEstablishmentPictures(response))
                setInProgress(false)
                return response
            })
            .catch((error) => {
                setInProgress(false)
                throw generateError(error)
            })
    }

    return {
        updateEstablishmentPictures,
        inProgress,
    }
}
